<template>
  <div class="img_btn_container" v-bind:class="class_name">
    <img src="../../assets/img/top/furo.png" />
    <div class="fukidashi_container">
      <div class="text_container">
        <p>明日やろう</p>
        <span class="circle">
          <img src="../../assets/img/common/arrow_pink.svg" />
        </span>
      </div>
      <img src="../../assets/img/top/fukidashi.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "furo",
  data() {
    return {
      class_name: "",
    };
  },
  mounted() {
    setTimeout(() => {
      this.class_name = "animation";
    }, 3300);
  },
};
</script>

<style scoped>
.img_btn_container {
  width: 23.3%;
  bottom: 28.5%;
  left: 66%;
}

.fukidashi_container {
  width: 80%;
  top: -40%;
  left: -58%;
}

.text_container {
  margin-top: calc(50% - 14px);
}

.animation {
  animation: 4.5s fuwafuwa infinite;
}

@keyframes fuwafuwa {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

@media only screen and (max-width: 600px) {
  .img_btn_container {
    width: 23%;
    bottom: -3%;
    left: 56%;
  }
  .fukidashi_container {
    display: none!important;
  }
}
</style>
